import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import { useState } from "react";
import HomePage from "./screens/home/homePage";
import SecurityCodes from "./screens/security/security";
import SignUp from "./screens/signUp/signup";
import ForgotPassword from "./screens/forgotPassword/ForgotPassword";
import OptionScreen from "./screens/landingPage/index";
import ProfileScreen from "./screens/profilePage/profile.js";
import Lynxid from "./screens/profilePage/Lynxid.js";
import LoginScreen from "./screens/login/loginPage.js";
import VerifyScreen from "./screens/signUp/verifyAccount.js";
import DetailsPage from "./screens/signUp/detailsPage.js";
import DOBScreen from "./screens/signUp/registration.js";
import PhotoScreen from "./screens/signUp/profilePhoto.js";
import SetPasswordScreen from "./screens/signUp/setPassword.js";
import Darktoggle from "./components/Darktoggle";
import ErrorAlert from "./components/ErrorAlert";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ element, isAuth, handleUnauthorized }) => {
  // console.log(isAuth);
  return isAuth
    ? element
    : (handleUnauthorized(), (<Navigate to="/login" replace />));
};

function App() {
  const token = useSelector((state) => state.auth.token);
  const isAuth = !!token;
  // console.log(isAuth);
  const [errorMessage, setErrorMessage] = useState("");

  const handleUnauthorized = () => {
    setErrorMessage("Not authorized, please login");
  };

  const closeAlert = () => {
    setErrorMessage("");
  };

  return (
    <div className="app">
      <header>
        <Darktoggle />
      </header>

      {errorMessage && (
        <ErrorAlert message={errorMessage} onClose={closeAlert} />
      )}

      <BrowserRouter>
        <Routes>
          <Route path="/" element={<OptionScreen />} />
          <Route path="/login" element={<LoginScreen />} />
          <Route
            path="/home"
            element={
              <ProtectedRoute
                element={<HomePage />}
                isAuth={isAuth}
                handleUnauthorized={handleUnauthorized}
              />
            }
          />
          <Route path="/register-rollNo" element={<SignUp />} />
          <Route
            path="/register-otp"
            element={
              <ProtectedRoute
                element={<VerifyScreen />}
                isAuth={true}
                handleUnauthorized={handleUnauthorized}
              />
            }
          />
          <Route
            path="/register-details"
            element={
              <ProtectedRoute
                element={<DetailsPage />}
                isAuth={isAuth}
                handleUnauthorized={handleUnauthorized}
              />
            }
          />
          <Route
            path="/register-dob-details"
            element={
              <ProtectedRoute
                element={<DOBScreen />}
                isAuth={isAuth}
                handleUnauthorized={handleUnauthorized}
              />
            }
          />
          <Route
            path="/register-profile-images"
            element={
              <ProtectedRoute
                element={<PhotoScreen />}
                isAuth={isAuth}
                handleUnauthorized={handleUnauthorized}
              />
            }
          />
          <Route
            path="/register-setPassword"
            element={
              <ProtectedRoute
                element={<SetPasswordScreen />}
                isAuth={isAuth}
                handleUnauthorized={handleUnauthorized}
              />
            }
          />
          <Route
            path="/security"
            element={
              <ProtectedRoute
                element={<SecurityCodes />}
                isAuth={isAuth}
                handleUnauthorized={handleUnauthorized}
              />
            }
          />
          <Route path="/forgotPassword" element={<ForgotPassword />} />
          {/* <Route path="/profile" element={<ProfileScreen />} /> */}
          <Route
            path="/profile"
            element={
              <ProtectedRoute
                element={<ProfileScreen />}
                isAuth={isAuth}
                handleUnauthorized={handleUnauthorized}
              />
            }
          />
           <Route
            path="/lynxid"
            element={
              <ProtectedRoute
                element={<Lynxid />}
                isAuth={isAuth}
                handleUnauthorized={handleUnauthorized}
              />
            }
              />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
